module.exports = __webpack_public_path__ + "img/star-2.0dd25550.svg";